import { Icon } from "@shared/antd/icon";
import React, { useEffect, useState } from "react";
import { Upload } from "antd";
import { getCubaREST } from "@cuba-platform/react";
import { FileDescriptor } from "cuba/entities/base/sys$FileDescriptor";
import { downloadFile } from "../../../util";
import { Button } from "@shared/antd/button";

interface MultiFileUploadProps {
  value?: FileDescriptor[];
  onChange?: (files: FileDescriptor[]) => void;
  isVisible?: boolean;
}

export const MultiFileUpload: React.FC<MultiFileUploadProps> = ({
  value,
  onChange,
  isVisible = true,
}) => {
  const [files, setFiles] = useState<FileDescriptor[]>(value || []);

  useEffect(() => {
    setFiles(value || []);
  }, [value]);

  const triggerChange = (updatedFiles: FileDescriptor[]) => {
    setFiles(updatedFiles);
    onChange && onChange(updatedFiles);
  };

  const handleChange = ({ fileList }: { fileList: any[] }) => {
    const updatedFiles = (fileList || []).map((f) => {
      const isDone = f.status === "done" && f.response;

      return {
        uid: f.uid,
        id: isDone ? f.response.id : f.id || f.uid,
        name: f.name,
        size: f.size,
        extension: f.type,
        status: f.status || "done",
        response: f.response,
      };
    });

    triggerChange(updatedFiles);
  };

  const handleRemove = (file: any) => {
    const updatedFiles = files.filter((f) => f.id !== (file.uid || file.key));
    triggerChange(updatedFiles);
  };

  const handleDownload = (file: any) => {
    const f = files.find((fi) => fi.id === (file.uid || file.key));
    if (!f) return;

    if (f.response && f.response.name) {
      const resp = f.response;
      downloadFile(
        resp.id,
        resp.name.split(".")[0],
        resp.name.split(".").pop()!,
        "Файл не найден",
      );
    } else {
      downloadFile(f.id, f.name!, f.extension!, "Файл не найден");
    }
  };

  if (!isVisible) {
    return (
      <div>
        {(files || []).map((f) => (
          <a
            key={f.id}
            style={{
              textDecoration: "underline",
              display: "block",
              cursor: "pointer",
            }}
            onClick={() =>
              downloadFile(f.id, f.name!, f.extension!, "Cannot find file")
            }
          >
            {f.name}
          </a>
        ))}
      </div>
    );
  }

  return (
    <Upload
      style={{ display: "inline-block" }}
      action={getCubaREST()!.getFileUploadURL()}
      headers={{ Authorization: "Bearer " + getCubaREST()!.restApiToken }}
      multiple
      showUploadList={{ showDownloadIcon: true, showRemoveIcon: true }}
      fileList={(files || []).filter(Boolean).map((f: any) => ({
        uid: f.uid || f.id,
        key: f.uid || f.id,
        name: f.name,
        status: f.status || "done",
        type: f.extension,
        size: f.size,
        id: f.id,
        response: f.response,
      }))}
      onChange={handleChange}
      onRemove={handleRemove}
      onDownload={handleDownload}
    >
      <Button type="primary">
        <Icon
          type={(files || []).length > 0 ? "plus" : "upload"}
          style={{ width: 30 }}
        />
      </Button>
    </Upload>
  );
};
